import React from "react"
import { Jumbotron, HeadNotification } from "../../components"
import Achievement from "./Achievement"
import RecentNews from "./RecentNews"
import BannerHome from "./BannerHome"
import bgimage from "../../assets/img/bgimage.png"

function HomePage() {
  return (
    <>
      <Jumbotron bgImage={bgimage}>
        <BannerHome />
      </Jumbotron>
      <HeadNotification />
      <Achievement />
      <hr className="uk-divider-icon"/>
      <RecentNews />
    </>
  )
}

export default HomePage
